var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popTitle",class:_vm.className},[_c('i',{staticClass:"line",style:(_vm.color)}),_c('i',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }